/**
 * World country names → ISO 3166-1 alpha-2 for flags and HQ display.
 * Source: THE_KYB_COUNTRY_CODES (KYB coverage) in general.const.ts — keep in sync when that list changes.
 */

export type WorldCountryIsoItem = { name: string; code: string };

export const WORLD_COUNTRY_ISO_CODES: readonly WorldCountryIsoItem[] = [
  { name: "Afghanistan", code: "AF" },
  { name: "Albania", code: "AL" },
  { name: "Algeria", code: "DZ" },
  { name: "American Samoa", code: "AS" },
  { name: "Andorra", code: "AD" },
  { name: "Angola", code: "AO" },
  { name: "Anguilla", code: "AI" },
  { name: "Antarctica", code: "AQ" },
  { name: "Antigua and Barbuda", code: "AG" },
  { name: "Argentina", code: "AR" },
  { name: "Armenia", code: "AM" },
  { name: "Aruba", code: "AW" },
  { name: "Australia", code: "AU" },
  { name: "Austria", code: "AT" },
  { name: "Azerbaijan", code: "AZ" },
  { name: "Bahamas", code: "BS" },
  { name: "Bahrain", code: "BH" },
  { name: "Bangladesh", code: "BD" },
  { name: "Barbados", code: "BB" },
  { name: "Belarus", code: "BY" },
  { name: "Belgium", code: "BE" },
  { name: "Belize", code: "BZ" },
  { name: "Benin", code: "BJ" },
  { name: "Bermuda", code: "BM" },
  { name: "Bhutan", code: "BT" },
  { name: "Bolivia", code: "BO" },
  { name: "Bosnia and Herzegovina", code: "BA" },
  { name: "Botswana", code: "BW" },
  { name: "Brazil", code: "BR" },
  { name: "British Indian Ocean Territory", code: "IO" },
  { name: "Brunei", code: "BN" },
  { name: "Bulgaria", code: "BG" },
  { name: "Burkina Faso", code: "BF" },
  { name: "Burma (Myanmar)", code: "MM" },
  { name: "Burundi", code: "BI" },
  { name: "Cambodia", code: "KH" },
  { name: "Cameroon", code: "CM" },
  { name: "Canada", code: "CA" },
  { name: "Cape Verde", code: "CV" },
  { name: "Cayman Islands", code: "KY" },
  { name: "Central African Republic", code: "CF" },
  { name: "Chad", code: "TD" },
  { name: "Chile", code: "CL" },
  { name: "China", code: "CN" },
  { name: "Christmas Island", code: "CX" },
  { name: "Cocos (Keeling) Islands", code: "CC" },
  { name: "Colombia", code: "CO" },
  { name: "Comoros", code: "KM" },
  { name: "Congo, Democratic Republic", code: "CD" },
  { name: "Congo, Republic", code: "CG" },
  { name: "Cook Islands", code: "CK" },
  { name: "Costa Rica", code: "CR" },
  { name: "Croatia", code: "HR" },
  { name: "Cuba", code: "CU" },
  { name: "Curacao", code: "CW" },
  { name: "Cyprus", code: "CY" },
  { name: "Czech Republic", code: "CZ" },
  { name: "Denmark", code: "DK" },
  { name: "Djibouti", code: "DJ" },
  { name: "Dominica", code: "DM" },
  { name: "Dominican Republic", code: "DO" },
  { name: "East Timor", code: "TL" },
  { name: "Ecuador", code: "EC" },
  { name: "Egypt", code: "EG" },
  { name: "El Salvador", code: "SV" },
  { name: "Equatorial Guinea", code: "GQ" },
  { name: "Eritrea", code: "ER" },
  { name: "Estonia", code: "EE" },
  { name: "Eswatini", code: "SZ" },
  { name: "Ethiopia", code: "ET" },
  { name: "Falkland Islands", code: "FK" },
  { name: "Faroe Islands", code: "FO" },
  { name: "Fiji", code: "FJ" },
  { name: "Finland", code: "FI" },
  { name: "France", code: "FR" },
  { name: "French Guiana", code: "GF" },
  { name: "French Polynesia", code: "PF" },
  { name: "French Southern Territories", code: "TF" },
  { name: "Gabon", code: "GA" },
  { name: "Gambia", code: "GM" },
  { name: "Georgia", code: "GE" },
  { name: "Germany", code: "DE" },
  { name: "Ghana", code: "GH" },
  { name: "Gibraltar", code: "GI" },
  { name: "Greece", code: "GR" },
  { name: "Greenland", code: "GL" },
  { name: "Grenada", code: "GD" },
  { name: "Guadeloupe", code: "GP" },
  { name: "Guam", code: "GU" },
  { name: "Guatemala", code: "GT" },
  { name: "Guernsey", code: "GG" },
  { name: "Guinea", code: "GN" },
  { name: "Guinea-Bissau", code: "GW" },
  { name: "Guyana", code: "GY" },
  { name: "Haiti", code: "HT" },
  { name: "Heard Island and McDonald Islands", code: "HM" },
  { name: "Honduras", code: "HN" },
  { name: "Hong Kong", code: "HK" },
  { name: "Hungary", code: "HU" },
  { name: "Iceland", code: "IS" },
  { name: "India", code: "IN" },
  { name: "Indonesia", code: "ID" },
  { name: "Iran", code: "IR" },
  { name: "Iraq", code: "IQ" },
  { name: "Ireland", code: "IE" },
  { name: "Israel", code: "IL" },
  { name: "Italy", code: "IT" },
  { name: "Ivory Coast", code: "CI" },
  { name: "Jamaica", code: "JM" },
  { name: "Japan", code: "JP" },
  { name: "Jersey", code: "JE" },
  { name: "Jordan", code: "JO" },
  { name: "Kazakhstan", code: "KZ" },
  { name: "Kenya", code: "KE" },
  { name: "Kiribati", code: "KI" },
  { name: "Korea, Dem. Republic of", code: "KP" },
  { name: "Kuwait", code: "KW" },
  { name: "Kyrgyzstan", code: "KG" },
  { name: "Laos", code: "LA" },
  { name: "Latvia", code: "LV" },
  { name: "Lebanon", code: "LB" },
  { name: "Lesotho", code: "LS" },
  { name: "Liberia", code: "LR" },
  { name: "Libya", code: "LY" },
  { name: "Liechtenstein", code: "LI" },
  { name: "Lithuania", code: "LT" },
  { name: "Luxembourg", code: "LU" },
  { name: "Macao (Macau)", code: "MO" },
  { name: "Macedonia", code: "MK" },
  { name: "Madagascar", code: "MG" },
  { name: "Malawi", code: "MW" },
  { name: "Malaysia", code: "MY" },
  { name: "Maldives", code: "MV" },
  { name: "Mali", code: "ML" },
  { name: "Malta", code: "MT" },
  { name: "Man Island", code: "IM" },
  { name: "Marshall Islands", code: "MH" },
  { name: "Martinique", code: "MQ" },
  { name: "Mauritania", code: "MR" },
  { name: "Mauritius", code: "MU" },
  { name: "Mayotte", code: "YT" },
  { name: "Mexico", code: "MX" },
  { name: "Micronesia", code: "FM" },
  { name: "Moldova", code: "MD" },
  { name: "Monaco", code: "MC" },
  { name: "Mongolia", code: "MN" },
  { name: "Montenegro", code: "ME" },
  { name: "Montserrat", code: "MS" },
  { name: "Morocco", code: "MA" },
  { name: "Mozambique", code: "MZ" },
  { name: "Namibia", code: "NA" },
  { name: "Nauru", code: "NR" },
  { name: "Nepal", code: "NP" },
  { name: "Netherlands", code: "NL" },
  { name: "Netherlands Antilles", code: "AN" },
  { name: "New Caledonia", code: "NC" },
  { name: "New Zealand", code: "NZ" },
  { name: "Nicaragua", code: "NI" },
  { name: "Niger", code: "NE" },
  { name: "Nigeria", code: "NG" },
  { name: "Niue", code: "NU" },
  { name: "Norfolk Island", code: "NF" },
  { name: "Northern Mariana Islands", code: "MP" },
  { name: "Norway", code: "NO" },
  { name: "Oman", code: "OM" },
  { name: "Pakistan", code: "PK" },
  { name: "Palau", code: "PW" },
  { name: "Palestinian Territories", code: "PS" },
  { name: "Panama", code: "PA" },
  { name: "Papua New Guinea", code: "PG" },
  { name: "Paraguay", code: "PY" },
  { name: "Peru", code: "PE" },
  { name: "Philippines", code: "PH" },
  { name: "Pitcairn", code: "PN" },
  { name: "Poland", code: "PL" },
  { name: "Portugal", code: "PT" },
  { name: "Puerto Rico", code: "PR" },
  { name: "Qatar", code: "QA" },
  { name: "Republic of Kosovo", code: "XK" },
  { name: "Reunion Island", code: "RE" },
  { name: "Romania", code: "RO" },
  { name: "Russia Federation", code: "RU" },
  { name: "Rwanda", code: "RW" },
  { name: "Saint Barthelemy", code: "BL" },
  { name: "Saint Kitts and Nevis", code: "KN" },
  { name: "Saint Lucia", code: "LC" },
  { name: "Saint Martin", code: "MF" },
  { name: "Saint Pierre and Miquelon", code: "PM" },
  { name: "Saint Vincent and the Grenadines", code: "VC" },
  { name: "Samoa", code: "WS" },
  { name: "San Marino", code: "SM" },
  { name: "Sao Tome and Principe", code: "ST" },
  { name: "Saudi Arabia", code: "SA" },
  { name: "Senegal", code: "SN" },
  { name: "Serbia", code: "RS" },
  { name: "Seychelles", code: "SC" },
  { name: "Sierra Leone", code: "SL" },
  { name: "Singapore", code: "SG" },
  { name: "Slovakia", code: "SK" },
  { name: "Slovenia", code: "SI" },
  { name: "Solomon Islands", code: "SB" },
  { name: "Somalia", code: "SO" },
  { name: "South Africa", code: "ZA" },
  { name: "South Georgia and the South Sandwich Islands", code: "GS" },
  { name: "South Korea", code: "KR" },
  { name: "South Sudan", code: "SS" },
  { name: "Spain", code: "ES" },
  { name: "Sri Lanka", code: "LK" },
  { name: "Sudan", code: "SD" },
  { name: "Suriname", code: "SR" },
  { name: "Svalbard and Jan Mayen", code: "SJ" },
  { name: "Sweden", code: "SE" },
  { name: "Switzerland", code: "CH" },
  { name: "Syria", code: "SY" },
  { name: "Taiwan", code: "TW" },
  { name: "Tajikistan", code: "TJ" },
  { name: "Tanzania", code: "TZ" },
  { name: "Thailand", code: "TH" },
  { name: "Togo", code: "TG" },
  { name: "Tokelau", code: "TK" },
  { name: "Tonga", code: "TO" },
  { name: "Trinidad and Tobago", code: "TT" },
  { name: "Tunisia", code: "TN" },
  { name: "Turkey", code: "TR" },
  { name: "Turkmenistan", code: "TM" },
  { name: "Turks and Caicos Islands", code: "TC" },
  { name: "Tuvalu", code: "TV" },
  { name: "Uganda", code: "UG" },
  { name: "Ukraine", code: "UA" },
  { name: "United Arab Emirates", code: "AE" },
  { name: "United Kingdom", code: "GB" },
  { name: "United States", code: "US" },
  { name: "Uruguay", code: "UY" },
  { name: "Uzbekistan", code: "UZ" },
  { name: "Vanuatu", code: "VU" },
  { name: "Vatican City State", code: "VA" },
  { name: "Venezuela", code: "VE" },
  { name: "Vietnam", code: "VN" },
  { name: "Virgin Islands, British", code: "VG" },
  { name: "Virgin Islands, US", code: "VI" },
  { name: "Wallis and Futuna", code: "WF" },
  { name: "Western Sahara", code: "EH" },
  { name: "Yemen", code: "YE" },
  { name: "Zambia", code: "ZM" },
  { name: "Zimbabwe", code: "ZW" },
] as const;

/** Profile HQ strings and common synonyms (lowercase keys). */
export const HEADQUARTERS_COUNTRY_ISO_ALIASES: Readonly<Record<string, string>> = {
  burma: "MM",
  "china (hong kong)": "HK",
  "china (mainland)": "CN",
  "cote d'ivoire": "CI",
  czechia: "CZ",
  "democratic people's republic of korea": "KP",
  "dprk": "KP",
  "korea, dem. republic of": "KP",
  "korea, democratic people's republic of": "KP",
  "korea, republic of": "KR",
  macao: "MO",
  myanmar: "MM",
  "north korea": "KP",
  "north macedonia": "MK",
  "republic of china": "TW",
  russia: "RU",
  uae: "AE",
  uk: "GB",
  "united arab emirates (uae)": "AE",
  "united states": "US",
  "united states (usa)": "US",
  "united states of america": "US",
  usa: "US",
};

const WORLD_ISO_BY_NAME_LOWER: Record<string, string> = Object.fromEntries(
  WORLD_COUNTRY_ISO_CODES.map((c) => [c.name.toLowerCase(), c.code]),
);

/** HQ strings in DB/UI often include trailing qualifiers, e.g. "China (Mainland)". */
export function normalizeHeadquartersCountryForLookup(country: string): string {
  return country.trim().replace(/\s*\([^)]*\)\s*$/g, "").trim();
}

/** Resolve headquarters country name (or 2-letter code) to ISO 3166-1 alpha-2. */
export function getIsoCountryCodeFromHeadquarters(country?: string | null): string | null {
  if (!country?.trim()) return null;
  const trimmed = country.trim();
  if (/^[A-Za-z]{2}$/.test(trimmed)) return trimmed.toUpperCase();
  const candidates = [
    trimmed.toLowerCase(),
    normalizeHeadquartersCountryForLookup(trimmed).toLowerCase(),
  ];
  for (const key of candidates) {
    const code =
      WORLD_ISO_BY_NAME_LOWER[key] ?? HEADQUARTERS_COUNTRY_ISO_ALIASES[key] ?? null;
    if (code && /^[A-Z]{2}$/i.test(code)) return code.toUpperCase();
  }
  return null;
}

const WORLD_ISO_BY_CODE: Record<string, string> = Object.fromEntries(
  WORLD_COUNTRY_ISO_CODES.map((c) => [c.code, c.name]),
);

/** Canonical English country name for an ISO code (first match in WORLD list). */
export function getCountryNameFromIsoCode(code?: string | null): string | null {
  if (!code?.trim()) return null;
  const upper = code.trim().toUpperCase();
  return WORLD_ISO_BY_CODE[upper] ?? null;
}

/** Display label for promo/UI: resolves HQ → canonical country name. */
export function getCountryDisplayLabelFromHeadquarters(country?: string | null): string | null {
  if (!country?.trim()) return null;
  const iso = getIsoCountryCodeFromHeadquarters(country);
  if (iso) {
    const canonical = getCountryNameFromIsoCode(iso);
    if (canonical) return canonical;
  }
  return normalizeHeadquartersCountryForLookup(country.trim()) || country.trim();
}

/** Optional demonym/adjective labels for promo copy (ISO 3166-1 alpha-2 keys). */
export const PROMO_COUNTRY_LABEL_BY_ISO: Readonly<Record<string, string>> = {
  AE: "UAE",
  AU: "Australian",
  BR: "Brazilian",
  CA: "Canadian",
  CN: "Chinese",
  CZ: "Czech",
  DE: "German",
  EG: "Egyptian",
  ES: "Spanish",
  FR: "French",
  GB: "United Kingdom",
  ID: "Indonesian",
  IN: "Indian",
  IT: "Italian",
  JP: "Japanese",
  KR: "South Korean",
  MX: "Mexican",
  MY: "Malaysian",
  NL: "Dutch",
  PL: "Polish",
  SA: "Saudi",
  SG: "Singapore",
  TH: "Thai",
  TR: "Turkish",
  US: "United States",
  VN: "Vietnamese",
  ZA: "South African",
};

/** Promo carousel copy label (demonym when defined, else canonical country name). */
export function getPromoCountryLabelFromHeadquarters(country?: string | null): string | null {
  const iso = getIsoCountryCodeFromHeadquarters(country);
  if (iso && PROMO_COUNTRY_LABEL_BY_ISO[iso]) return PROMO_COUNTRY_LABEL_BY_ISO[iso];
  return getCountryDisplayLabelFromHeadquarters(country);
}
